/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DailyChargingSuccessRateDto } from "./DailyChargingSuccessRateDto";
import {
    DailyChargingSuccessRateDtoFromJSON,
    DailyChargingSuccessRateDtoFromJSONTyped,
    DailyChargingSuccessRateDtoToJSON,
} from "./DailyChargingSuccessRateDto";

/**
 *
 * @export
 * @interface GroupedTrendItem
 */
export interface GroupedTrendItem {
    /**
     * The unique identifier for this group (e.g., device identity or device group tag)
     * @type {string}
     * @memberof GroupedTrendItem
     */
    groupId?: string;
    /**
     * The display name for this group
     * @type {string}
     * @memberof GroupedTrendItem
     */
    groupName?: string;
    /**
     * Array of daily charging success rate data points for this group
     * @type {Array<DailyChargingSuccessRateDto>}
     * @memberof GroupedTrendItem
     */
    dailyTrends?: Array<DailyChargingSuccessRateDto>;
}

/**
 * Check if a given object implements the GroupedTrendItem interface.
 */
export function instanceOfGroupedTrendItem(
    value: object,
): value is GroupedTrendItem {
    return true;
}

export function GroupedTrendItemFromJSON(json: any): GroupedTrendItem {
    return GroupedTrendItemFromJSONTyped(json, false);
}

export function GroupedTrendItemFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): GroupedTrendItem {
    if (json == null) {
        return json;
    }
    return {
        groupId: json["groupId"] == null ? undefined : json["groupId"],
        groupName: json["groupName"] == null ? undefined : json["groupName"],
        dailyTrends:
            json["dailyTrends"] == null
                ? undefined
                : (json["dailyTrends"] as Array<any>).map(
                      DailyChargingSuccessRateDtoFromJSON,
                  ),
    };
}

export function GroupedTrendItemToJSON(value?: GroupedTrendItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        groupId: value["groupId"],
        groupName: value["groupName"],
        dailyTrends:
            value["dailyTrends"] == null
                ? undefined
                : (value["dailyTrends"] as Array<any>).map(
                      DailyChargingSuccessRateDtoToJSON,
                  ),
    };
}
